import { render, staticRenderFns } from "./MoveAssetsBetweenOrgs.vue?vue&type=template&id=7a5fbda8&scoped=true"
import script from "./MoveAssetsBetweenOrgs.vue?vue&type=script&lang=js"
export * from "./MoveAssetsBetweenOrgs.vue?vue&type=script&lang=js"
import style0 from "./MoveAssetsBetweenOrgs.vue?vue&type=style&index=0&id=7a5fbda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5fbda8",
  null
  
)

export default component.exports